import axios from "axios";
const jsonConfig = require("../../config.json");

const  getBarChartData = async () =>{
    try{
    const getAllResponse = await axios.get(jsonConfig.apiUrl + "bargraphdata", {
           headers: {
             "x-functions-key": jsonConfig.key,
          },
        });
        return Promise.resolve(getAllResponse)

    }catch (error) {
       return Promise.reject(error)
    }
  }
export default  getBarChartData;